import styled from "styled-components";

export const PayAttentionInfoContainer = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));
